import React, { useEffect, useState } from "react";
import AppLayout from "../../components/AppLayout";
import StatsCard from "../../components/StatsCard";
import { Users, Wallet, ShieldCheck, CreditCard } from "lucide-react";
import api, { formatCurrency, formatDate } from "../../lib/api";
import BetaAccessPanel from "./BetaAccessPanel";
import AccountSecurityPanel from "./AccountSecurityPanel";
import AdminEmailPanel from "./AdminEmailPanel";

export default function AdminDashboard() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/admin/dashboard")
      .then((r) => setData(r.data))
      .catch(() => setData({ totals: {}, recent_users: [] }));
  }, []);

  if (!data) {
    return (
      <AppLayout>
        <div className="flex h-64 items-center justify-center text-ink-500" data-testid="admin-loading">
          <div className="h-6 w-6 animate-spin rounded-full border-2 border-brand border-t-transparent" />
        </div>
      </AppLayout>
    );
  }

  const t = data?.totals || {};

  return (
    <AppLayout>
      <div>
        <p className="label-caps">Platform admin</p>
        <h1 className="h2">Admin dashboard</h1>
        <p className="text-sm text-ink-500">Platform-wide overview of users, teams, and payment volume.</p>
      </div>

      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <StatsCard label="Users" value={t.users ?? 0} icon={Users} testid="admin-stat-users" />
        <StatsCard label="Coaches" value={t.coaches ?? 0} icon={ShieldCheck} accent="brand" testid="admin-stat-coaches" />
        <StatsCard label="Parents" value={t.parents ?? 0} icon={Users} accent="emerald" testid="admin-stat-parents" />
        <StatsCard label="Confirmed volume" value={formatCurrency(t.volume_confirmed || 0)} icon={Wallet} accent="emerald" testid="admin-stat-volume" />
      </div>

      <div className="mt-6 grid gap-4 sm:grid-cols-3">
        <StatsCard label="Teams" value={t.teams ?? 0} icon={Users} testid="admin-stat-teams" />
        <StatsCard label="Players" value={t.players ?? 0} icon={Users} testid="admin-stat-players" />
        <StatsCard label="Charges" value={t.charges ?? 0} icon={CreditCard} testid="admin-stat-charges" />
      </div>

      <div className="mt-8 rounded-xl border border-ink-100 bg-white p-6 shadow-sm">
        <h3 className="h3">Recent users</h3>
        <div className="mt-4 divide-y divide-ink-100">
          {(data?.recent_users || []).map((u) => (
            <div key={u.id} className="flex items-center justify-between py-3">
              <div>
                <p className="font-semibold text-ink-900">{u.name}</p>
                <p className="text-xs text-ink-500">{u.email} · {u.role}</p>
              </div>
              <p className="text-xs text-ink-500">{formatDate(u.created_at)}</p>
            </div>
          ))}
        </div>
      </div>

      <BetaAccessPanel />
      <AccountSecurityPanel />
      <AdminEmailPanel />
    </AppLayout>
  );
}
